'use client';

import { Tab } from '@common/components';
import { SvgManual } from '@common/icon';
import { usePathname } from 'next/navigation';
import type { PropsWithChildren } from 'react';

import { CustomLink } from '@/app/_components/CustomLink';
import { DesktopTitle } from '@/app/donation/(private)/my/_components/DesktopTitle';
import { PageNavigation } from '@/components/client';
import { DONATION_ROUTES } from '@/constants';

const DonationMyEtcLayout = ({ children }: PropsWithChildren) => {
  const pathname = usePathname() ?? DONATION_ROUTES.MY_ETC_EVENT.pathname;

  const title = (() => {
    switch (pathname) {
      case DONATION_ROUTES.MY_ETC_NOTICE.pathname:
        return '공지사항';
      case DONATION_ROUTES.MY_ETC_EVENT.pathname:
        return '이벤트';
      default:
        return null;
    }
  })();

  return (
    <article className="flex flex-col">
      <PageNavigation isNotUsedHomeButton donationHomeButton>
        <CustomLink
          href={DONATION_ROUTES.GUIDE.pathname}
          aria-label="가이드 페이지로 이동"
        >
          <SvgManual className="size-24 text-Gray-900" />
        </CustomLink>
      </PageNavigation>
      {title ? <DesktopTitle className="mb-20">{title}</DesktopTitle> : null}
      <Tab value={pathname}>
        <Tab.Item value={DONATION_ROUTES.MY_ETC_EVENT.pathname}>
          <CustomLink
            href={DONATION_ROUTES.MY_ETC_EVENT.pathname}
            aria-label="이벤트 페이지로 이동"
            className="size-full flex-center"
            replace
          >
            이벤트
          </CustomLink>
        </Tab.Item>
        <Tab.Item value={DONATION_ROUTES.MY_ETC_NOTICE.pathname}>
          <CustomLink
            href={DONATION_ROUTES.MY_ETC_NOTICE.pathname}
            aria-label="공지사항 페이지로 이동"
            className="size-full flex-center"
            replace
          >
            공지사항
          </CustomLink>
        </Tab.Item>
      </Tab>
      {children}
    </article>
  );
};

export default DonationMyEtcLayout;
